import {Flex, Text, useColorModeValue} from "@chakra-ui/react";
import {REACT_APP_ANALYTICS_URL} from "../../../constants/config";
import { KEYS } from "../../../constants/keys";
import {IframeResizer} from "@open-iframe-resizer/react";

function Dashboard() {

    const token = localStorage.getItem(KEYS.token);
    const textColor = useColorModeValue("gray.700", "white");

    const getAnalyticsUrl = () => {
        if (!REACT_APP_ANALYTICS_URL?.trim()) {
            return null;
        }

        try {
            const url = new URL(REACT_APP_ANALYTICS_URL, window.location.origin);
            url.searchParams.set("token", token ?? "");
            return url.toString();
        } catch {
            return null;
        }
    };

    const analyticsUrl = getAnalyticsUrl();

    return (
        <>
            <Flex direction="column" style={{ marginTop: "25px" }}>
                <Flex w="100%" h="100vh" px="30px" justify="space-between" align="center" gap="4"
                      direction={{sm: "column", md: "column"}}>
                    {analyticsUrl ? (
                        <IframeResizer
                            title="Dashboard"
                            src={analyticsUrl}
                            style={{ width: '100%', height: '100vh', border: 0 }}
                        />
                    ) : (
                        <Flex w="100%" h="100%" align="center" justify="center">
                            <Text color={textColor} fontSize="md" fontWeight="bold">
                                Dashboard indisponível
                            </Text>
                        </Flex>
                    )}
                </Flex>
            </Flex>
        </>
    )
}

export default Dashboard;
